import React from 'react';
import { useTranslation } from 'react-i18next';
import { ForecastVsStockMeter } from './ForecastVsStockMeter';
import { PlannedVsActualMeter } from './PlannedVsActualMeter';
import type { EnrichedFertilizerStockUsageRow } from '../../utils/fertilizerStockUsageMath';

export interface FertilizerStockBarsRowProps {
  row: EnrichedFertilizerStockUsageRow;
}

export const FertilizerStockBarsRow: React.FC<FertilizerStockBarsRowProps> = ({ row }) => {
  const { t } = useTranslation();
  return (
    <div className="fsu-row">
      <div className="fsu-product">
        <div className="fsu-product-name">{row.productName}</div>
        <div className="fsu-product-unit">
          {t('nutrition.dashboard.fertilizerStockUsage.unit', { unit: row.unit ?? '—' })}
        </div>
      </div>
      <ForecastVsStockMeter row={row} />
      <PlannedVsActualMeter row={row} />
    </div>
  );
};

export default FertilizerStockBarsRow;
